import { UploadFile } from "@mui/icons-material";
import { Box, Tooltip, Button } from "@mui/material";

const ReplaceDocument = ({ selectedFileName, handleFileSelect, rowId }) => {
  return (
    <Box>
      <Tooltip title={"Click to replace Document"}>
        <Button component="label" startIcon={<UploadFile />}>
          {!selectedFileName ? "REPLACE DOCUMENT" : selectedFileName}

          <input id="file-input" type="file" hidden onChange={(e) => handleFileSelect(e, rowId)} />
        </Button>
      </Tooltip>
    </Box>
  );
};

export default ReplaceDocument;
